import React, { useRef } from 'react'
import Title from '../Shared/Title/Title'
import * as styles from './regerativeProductCards.module.scss'
import { GatsbyImage } from 'gatsby-plugin-image'
import { Swiper, SwiperSlide } from "swiper/react"
import { Link } from 'gatsby'
import { useLocalPath } from '../hooks/useLocalPath'

const RegerativeProductCards = ({ gridItems }) => {
  const { otherPages } = gridItems
  const swiperRef = useRef()
  return (
    <div className="container">
      <div className={styles.wrapper}>
        <div>
          <Swiper
            ref={swiperRef}
            loop={true}
            spaceBetween={0}
            breakpoints={{
              320: {
                slidesPerView: 1,
                centeredSlides: true
              },
              520: {
                slidesPerView: 3,
                centeredSlides: true
              },
              767: {
                slidesPerView: 3,
              },
              1070: {
                slidesPerView: 4,
              },
            }}
          // centeredSlides={true}
          >
            {otherPages && otherPages.map((item: any, id: number) => {
              const { image, title, subTitle, slug } = item
              return (
                <SwiperSlide key={id}>
                  <Link to={useLocalPath(slug)} className={styles.card} >
                    <GatsbyImage image={image.gatsbyImageData} alt={`${image.title} image`} className={styles.cardImage} />
                    <div className={styles.detail}>
                      <div className={styles.title}>{title}</div>
                      <div className={styles.subtitle}><Title title={subTitle} /></div>
                    </div>
                  </Link>
                </SwiperSlide>
              )
            })}
          </Swiper>
        </div>
      </div>
    </div>
  )
}

export default RegerativeProductCards

